import { useState } from 'react';
import { updateJobStatus } from '../api/jobs-api';
import { extractApiErrorMessage } from '@/lib/utils';
import type { JobStatus, JobDetailDto, JobStatusUpdateDto } from '../types';

/**
 * Hook for updating job status with optional closing details
 */
export function useUpdateJobStatus() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateStatus = async (
    jobId: number,
    newStatus: JobStatus,
    closingComments?: string,
    completedDate?: string,
    closedDate?: string
  ): Promise<JobDetailDto | null> => {
    setIsUpdating(true);
    setError(null);

    try {
      const statusUpdate: JobStatusUpdateDto = {
        newStatus,
        closingComments,
        completedDate,
        closedDate,
      };

      const updatedJob = await updateJobStatus(jobId, statusUpdate);
      return updatedJob;
    } catch (err) {
      const errorMessage = extractApiErrorMessage(err, 'Failed to update job status');
      setError(errorMessage);
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updateStatus,
    isUpdating,
    error,
  };
}
